<div class="header" [ngStyle]="{'background-color': color}">
  <div *ngIf="title" class="title">{{ title }}</div>
  <div *ngIf="subtitle" class="subtitle">{{ subtitle }}</div>
</div>
<div class="content" [ngStyle]="{'border-radius': radius ? '0 0 1.5em 1.5em' : '', 'box-shadow': radius ? 'rgba(0, 0, 0, 0.24) 0px 0.3em 0.8em' : ''}">
  <ng-content></ng-content>
</div>
